import { render, staticRenderFns } from "./UploadDetails.vue?vue&type=template&id=737a4bac&scoped=true&"
import script from "./UploadDetails.vue?vue&type=script&lang=js&"
export * from "./UploadDetails.vue?vue&type=script&lang=js&"
import style0 from "./UploadDetails.css?vue&type=style&index=0&id=737a4bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a4bac",
  null
  
)

export default component.exports